import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Bags from './pages/Bags';
import Sales from './pages/Sales';
import Parties from './pages/Parties';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Expenses from './pages/Expenses';
import BagTracking from './pages/BagTracking';
import Master from './pages/Master';
import VerifyEmail from './pages/VerifyEmail';
import Contact from './pages/Contact';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import './App.css';

function App() {
  // Landing route depends on role — admin sees Dashboard, staff sees Bags
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/master" element={<ProtectedRoute superadminOnly><Master /></ProtectedRoute>} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<RoleHome />} />
            <Route path="dashboard" element={<ProtectedRoute adminOnly><Dashboard /></ProtectedRoute>} />
            <Route path="bags" element={<Bags />} />
            <Route path="sales" element={<Sales />} />
            <Route path="parties" element={<Parties />} />
            <Route path="expenses" element={<Expenses />} />
            <Route path="bag-tracking" element={<BagTracking />} />
            <Route path="reports" element={<ProtectedRoute adminOnly><Reports /></ProtectedRoute>} />
            <Route path="settings" element={<ProtectedRoute adminOnly><Settings /></ProtectedRoute>} />
            <Route path="contact" element={<Contact />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

const RoleHome = () => {
  const { user } = useAuth();
  if (user?.role === 'superadmin') return <Navigate to="/master" replace />;
  if (user?.role === 'staff') return <Navigate to="/bags" replace />;
  return <Dashboard />;
};

export default App;